import { useRef } from "react";
import {
  AddressEditor,
  addressValidationSchema,
  Button,
  FormSectionDivider,
  FormSectionHeader,
  SlideOutModal,
  SlideOutModalProps,
} from "../../../components";
import * as yup from "yup";
import { Formik } from "formik";
import { Form, Row, Col, FloatingLabel, Button as BSButton } from "react-bootstrap";
import { OrganizationModel } from "../../../data/entities";
import { sharedProperty } from "../../../hooks";
import { AddressService } from "../../../services";
import { getUserTenantId } from "../../../app";
import { useSelector } from "react-redux";

export interface AddOrganizationModalProps extends SlideOutModalProps {
  showAddState: sharedProperty<boolean>;
  onSubmit: any;
}

export function AddOrganizationModal(props: Readonly<AddOrganizationModalProps>) {

  const submitRef = useRef<HTMLButtonElement>(null);
  const tenantId = useSelector(getUserTenantId());

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    address: addressValidationSchema
  });

  return (
    <SlideOutModal
      {...props}
      title="Add New Organization"
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button onClick={() => submitRef.current?.click()} variant="primary" className="w-100">
                Add
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          name: '',
          address: {
            streetAddress: '',
            streetAddress2: '',
            city: '',
            postalCode: '',
            regionId: 1,
          }
        }}
        onSubmit={async (values) => {
          const addressInput = {
            id: 0,
            streetAddress: values.address.streetAddress,
            streetAddress2: values.address.streetAddress2,
            city: values.address.city,
            postalCode: values.address.postalCode,
            regionId: values.address.regionId,
          }

          const addressService = new AddressService();
          const result = await addressService.insert(addressInput);

          const {address, ...inputValues} = values; 
          const organization = {
            ...inputValues,
            paymentOptions:"",
            tenantId: tenantId,
            address: result,
          } as OrganizationModel;

          props.onSubmit(organization);
          props.showAddState.setter(false);
        }}

      >
        {({ values, handleSubmit, handleChange, setFieldValue, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit} className="px-2 pt-2">

              {/* Organization details */}
              <FormSectionHeader>Organization Details</FormSectionHeader>
              <Row>
                <Col>
                  <FloatingLabel label="Name" className="mb-3">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Organization Name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={touched.name && !!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>

              <FormSectionDivider />

              {/* Address */}
              <FormSectionHeader>Address</FormSectionHeader>
              <AddressEditor/>

              <BSButton ref={submitRef} type="submit" size="lg" className="d-none" />
            </Form>
          )
        }}
      </Formik>
    </SlideOutModal>
  );
}

export default AddOrganizationModal;
